import http from '../http';

// 获取预订单和房间信息
const fetchOrderInfo = (params) => {
  return http({
    url: `/reservation/${params.resvNo}/settle`,
  });
};

// 获取查房列表
const fetchCheckRoomList = (params) => {
  return http({
    url: `/check-room/list/${params.resvNo}`,
  });
};

// 获取结账信息
const fetchSettleInfo = (params) => {
  return http({
    url: `/bill/settle/${params.resvNo}`,
    params,
  });
};

// 获取结账步骤信息
const fetchSettleStepInfo = (params) => {
  return http({
    url: `/bill/settle/step/${params.resvNo}`,
  });
};

// 取消预订、退房
const settleResvOrder = (data) => {
  return http({
    url: '/reservation/settle',
    method: 'POST',
    data,
  });
};

// 获取续住明细
const fetchOverStayInfo = (params) => {
  return http({
    url: `/order/detail/${params.recNo}/extensions`,
  });
};

// 修改续住渠道单号
const editChannelNo = (data) => {
  return http({
    url: '/order/detail/extension',
    method: 'PUT',
    data,
  });
};

export {
  fetchOrderInfo,
  fetchCheckRoomList,
  fetchSettleInfo,
  fetchSettleStepInfo,
  settleResvOrder,
  fetchOverStayInfo,
  editChannelNo,
};
